import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestExportGet = {
    path: "/export",
    method: RouteHttpVerb.GET
};
